// eslint-disable-next-line import/prefer-default-export
export function calculateAdvanceAmount(unitValue, quantity, progressPercent = 0) {
  return Math.round((unitValue * quantity) * progressPercent * 100) / 100;
}
